import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

function AdsGenerationIcon(props: SvgIconProps) {
	return (
		<SvgIcon viewBox="0 0 20 21" {...props}>
			<rect x="0.175768" y="0.675768" width="19.6485" height="19.6485" rx="3.82423" fill="#109DBF" />
			<rect
				x="0.175768"
				y="0.675768"
				width="19.6485"
				height="19.6485"
				rx="3.82423"
				stroke="#B3B3B9"
				strokeWidth="0.351536"
				fill="none"
			/>
			<path
				d="M9.95812 6.125H5.625V16.125H13.75V11.125M11.25 13.625H8.125M11.875 6.125V4.875M13.75 6.75L15 5.5M14.375 8.625H15.625M8.125 11.125H11.25V8.625H8.125V11.125Z"
				stroke="white"
				strokeLinecap="round"
				strokeLinejoin="round"
				fill="none"
			/>
		</SvgIcon>
	);
}

export default AdsGenerationIcon;
